import axios, { AxiosRequestConfig } from "axios";
import { PaymentProvider } from "../models/PaymentProvider";
import getErrorDetails from "./helpers/getErrorDetails";
import { List } from "./helpers/pagination";

export type GetPaymentsProviders = (
  options?: AxiosRequestConfig
) => Promise<List<PaymentProvider>>;

export const getPaymentsProviders: GetPaymentsProviders = async (options) => {
  try {
    const response = await axios.get<PaymentProvider[]>(
      `/providers/payments`,
      options
    );
    const { data = [] } = response;

    return {
      list: data,
    } as List<PaymentProvider>;
  } catch (error) {
    throw getErrorDetails(error);
  }
};
